<style>
    /* Puedes ponerlo en tu .css correspondiente */
.custom-multiselect {
  position: relative;
  width: 100%;
}
.selected-items {
  border: 1px solid #ccc;
  padding: 8px;
  cursor: pointer;
  height: 40px;
  background: #fff;
  border-radius: 4px;

  white-space: nowrap;          /* ❗ Fuerza una sola línea */
  overflow: hidden;             /* Oculta lo que se pasa del contenedor */
  text-overflow: ellipsis;      /* Muestra "..." */
  display: flex;    
 justify-content: space-between;

  word-break: break-word;   /* Corta las palabras largas si es necesario */
  overflow-wrap: break-word;
  overflow-y: hidden; 

  font-family: 'Arial', sans-serif; /* Cambiá por la que quieras */
  font-size: 12px;      
  font-weight: bold;   

}

.selected-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* .arrow {
  float: right;
  font-size: 10px;
} */
.custom-arrow {
  flex-shrink: 0;
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  color: #555; /* Podés cambiar el color del ícono acá */
}


.dropdown {
  position: absolute;
  background: #fff;
  border: 1px solid #ccc;
  width: 400px;
  z-index: 100;
  max-height: 400px;
  overflow-y: auto;
  border-radius: 4px;
  margin-top: 2px;
}
.search-input {
  /* width: 95%; */
  margin: 8px;
  /* padding: 4px; */
  width: 95%;
  padding: 6px 30px 6px 8px;  /* deja espacio para el ícono */
  font-size: 14px;
  height: 100%;
}
.options-list {
  max-height: 450px;
  overflow-y: auto;
  padding: 8px;

}

.options-label {
  font-weight: bold;   /* Esto pone el texto en negrita */
  display: flex;
  align-items: left;
  margin-bottom: 8px;

   max-width: 100%;           /* Limita el ancho al contenedor */
  white-space: nowrap;       /* Evita salto de línea */
  overflow: hidden;          /* Oculta el texto que se sale */
  text-overflow: ellipsis;
}

.option-label input[type="checkbox"] {
  width: 20px;         /* Tamaño del checkbox */
  height: 20px;        /* Tamaño del checkbox */
  accent-color: #007749; /* Color del checkbox (azul Material) */
  margin-right: 8px;
  vertical-align: middle;
  flex-shrink: 0; 
  
}

.option-label {
font-weight: bold;
font-size: 12px;
display: block;
}



.search-container {
  position: relative;
  margin: 8px;
  height: 34px;
}

.search-icon {
  position: absolute;
  top: 25px;
  right: 20px; 
  transform: translateY(-50%);
  font-size: 14px;
  color: #888;
}

</style>

<nb-tabset>
    <nb-tab tabTitle="Consulta" tabIcon="search-outline" responsive style="height: 75vh">
        <div class="col-12">
            <p class="Titulo">Consulta - Criterios de Similitud</p>
            <button nbButton shape="round" size="small" class="buttontz" style="margin-right: -15px !important; margin-bottom: 15px !important" (click)="traerDatos()">
                <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
            </button>             
            <app-spinner *ngIf="!showGrilla" ></app-spinner>
            <table [nbTreeGrid]="source" *ngIf="showGrilla">

                <tr nbTreeGridHeaderRow *nbTreeGridHeaderRowDef="allColumns"></tr>
                <tr nbTreeGridRow *nbTreeGridRowDef="let row; columns: allColumns"></tr>
            
                <ng-container [nbTreeGridColumnDef]="customColumn">
                    <th nbTreeGridHeaderCell *nbTreeGridHeaderCellDef>
                    {{customColumn}}
                    </th>
                    <td nbTreeGridCell *nbTreeGridCellDef="let row" (click)="stateTreeGrid()">
                    <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
                    {{row.data[customColumn]}}
                    </td>
                </ng-container>
                <ng-container *ngFor="let column of defaultColumns; let index = index"
                                [nbTreeGridColumnDef]="column">
                    <th nbTreeGridHeaderCell *nbTreeGridHeaderCellDef>
                    {{column}}
                    </th>
                    <td nbTreeGridCell *nbTreeGridCellDef="let row">{{row.data[column] || '-'}}</td>
                </ng-container>
            </table>
        </div>
    </nb-tab>
    <nb-tab *ngIf="usersRol.GESTIONAR_CRITERIOS_SIMILITUD" tabTitle="Alta" tabIcon="upload-outline" responsive style="height: 75vh;">
        <div class="row">
            <div class="col-3 float-left">
                <p class="Titulo">Criterios de Similitud</p>
                <p>
                    <mat-form-field class="altaLabel">
                        <mat-label>Ingresar Descripción</mat-label>
                        <input matInput #message1 maxlength="80" [(ngModel)]="descripcionAlta" name="descripcionAlta">
                        <mat-hint align="end">{{message1.value.length}} / 80</mat-hint>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field class="altaLabel">
                        <mat-label>Ingresar Descripción Breve</mat-label>
                        <input matInput #message2 maxlength="40" [(ngModel)]="descripcionBreveAlta"
                            name="descripcionBreveAlta">
                        <mat-hint align="end">{{message2.value.length}} / 40</mat-hint>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field class="altaLabel">
                        <mat-label>Ingresar Número de Orden</mat-label>
                        <input matInput #message3 maxlength="40" name="orden" type="number" min="0"
                            [(ngModel)]="OrdenAlta" name="OrdenAlta">
                        <mat-hint align="end">{{message3.value.length}} / 40</mat-hint>
                    </mat-form-field>
                </p>
                <p>
                    <app-spinner *ngIf="showSpinnerGuardar" ></app-spinner>
                    <button nbButton size="tiny" status="primary" class="buttontz" *ngIf="!showSpinnerGuardar"
                        (click)="guardarCriterio()">Guardar</button>
                </p>
            </div>
            <div class="col-3 dropdownSelect">
                 <!-- <p-multiSelect id="inputSeveridad" defaultLabel="Severidad" [style]="{'width':'100%','height':'38px'}"
                    name="ctrlMedioEgreso" [disabled]="" [options]="severidad" [(ngModel)]="severidadProcesado"
                    [showToggleAll]="false">
                </p-multiSelect>  -->

                <!-- <nb-select
                id="inputSeveridad"
                placeholder="Severidad"
                class="text-h2" 
                [multiple]="true"
                name="ctrlMedioEgreso"
                [(ngModel)]="severidadProcesado"
                fullWidth
                >
                <nb-option *ngFor="let option of severidad" [value]="option.value">
                    {{ option.label }}
                </nb-option>
                </nb-select>  -->

                <!-- <nb-select
                    id="inputSeveridad"
                    placeholder="Severidad"
                    class="text-h2" 
                    [multiple]="true"
                    name="ctrlMedioEgreso"
                    [(ngModel)]="severidadProcesado"
                    fullWidth
                    >
                    <nb-option-group>
                        <nb-form-field>
                        <input
                            nbInput
                            placeholder="Buscar..."
                            [(ngModel)]="searchTerm"
                            (ngModelChange)="filterSeveridadOptions()"
                            style="width: 100%;" (click)="$event.stopPropagation()" />
                        </nb-form-field>
                    </nb-option-group>

                    <nb-option *ngFor="let option of filteredSeveridad" [value]="option.value">
                        {{ option.label }}
                    </nb-option>
                </nb-select> -->
                <!-- Multiselect personalizado con filtro -->
                 
                    <div class="custom-multiselect" id="dropdownSeveridad">
                        <div class="selected-items" (click)="toggleDropdown($event)">
                             <span class="selected-text">{{ getSeveridadProcesadoLabel() }}</span>
                            <span class="custom-arrow">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <rect width="24" height="24" opacity="0"></rect>
                                <path d="M12 15.5a1 1 0 0 1-.71-.29l-4-4a1 1 0 1 1 1.42-1.42L12 13.1l3.3-3.18a1 1 0 1 1 1.38 1.44l-4 3.86a1 1 0 0 1-.68.28z"></path>
                                </svg>
                            </span>
                        </div>
                        <div class="dropdown" *ngIf="dropdownOpen" (click)="$event.stopPropagation()">
                            <span class="search-icon">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1_2)">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.67602 11.0265C3.6661 11.688 4.83011 12.0411 6.02086 12.0411C6.81149 12.0411 7.59438 11.8854 8.32483 11.5828C8.87005 11.357 9.37808 11.0526 9.83317 10.6803L12.9769 13.8241C13.0323 13.8801 13.0983 13.9245 13.171 13.9548C13.2438 13.985 13.3219 14.0003 13.4007 14C13.4795 14.0003 13.5575 13.985 13.6303 13.9548C13.7031 13.9245 13.7691 13.8801 13.8244 13.8241C13.9367 13.7116 13.9998 13.5592 13.9998 13.4003C13.9998 13.2414 13.9367 13.089 13.8244 12.9765L10.6807 9.8328C11.053 9.37773 11.3573 8.86972 11.5831 8.32452C11.8857 7.59408 12.0414 6.81119 12.0414 6.02056C12.0414 4.8298 11.6883 3.66579 11.0268 2.67572C10.3652 1.68564 9.42494 0.913972 8.32483 0.45829C7.22472 0.00260857 6.01418 -0.116618 4.84631 0.115686C3.67844 0.34799 2.60568 0.921393 1.76369 1.76338C0.921698 2.60537 0.348296 3.67813 0.115991 4.84601C-0.116313 6.01388 0.00291375 7.22441 0.458595 8.32452C0.914277 9.42464 1.68595 10.3649 2.67602 11.0265ZM3.35565 2.0158C4.14456 1.48867 5.07206 1.20731 6.02086 1.20731C7.29317 1.20731 8.51338 1.71274 9.41304 2.6124C10.3127 3.51206 10.8181 4.73226 10.8181 6.00457C10.8181 6.95337 10.5368 7.88088 10.0096 8.66978C9.48251 9.45868 8.73328 10.0736 7.85669 10.4367C6.98011 10.7997 6.01554 10.8947 5.08496 10.7096C4.15439 10.5245 3.2996 10.0676 2.62869 9.39674C1.95778 8.72583 1.50089 7.87104 1.31579 6.94046C1.13068 6.00989 1.22568 5.04532 1.58878 4.16874C1.95187 3.29215 2.56675 2.54292 3.35565 2.0158Z" fill="currentColor"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_1_2">
                                    <rect width="14" height="14" fill="white"/>
                                    </clipPath>
                                </defs>
                                </svg>
                            </span>
                            <input
                            type="text"
                            placeholder="Buscar..."
                            [(ngModel)]="searchTerm"
                            (ngModelChange)="filterSeveridadOptions()"
                            class="search-input"
                            />
                            <div class="options-list">
                            <label class="option-label" *ngFor="let option of filteredSeveridad">
                                <input
                                type="checkbox"
                                [checked]="isSelected(option)"
                                (change)="toggleOption(option)"
                                />
                                {{ option.label }}
                            </label>
                            </div>
                        </div>
                    </div>

            </div>
            <div class="col-3 dropdownSelect">
                <!-- <p-multiSelect id="inputZonaCuadrante" defaultLabel="Zona Cuadrante"
                    [style]="{'width':'100%','height':'38px'}" name="ctrlMedioEgreso" [disabled]=""
                    [options]="zonaCuadrante" [(ngModel)]="zonaCuadranteProcesado" [showToggleAll]="false">
                </p-multiSelect>  -->
                 <!-- <nb-select
                    id="inputZonaCuadrante"
                    placeholder="Zona Cuadrante"
                    [multiple]="true"
                    name="ctrlMedioEgreso"
                    [(ngModel)]="zonaCuadranteProcesado"
                    fullWidth
                >
                    <nb-option *ngFor="let option of zonaCuadrante" [value]="option.value">
                    {{ option.label }}
                    </nb-option>
                </nb-select> -->

                <div class="custom-multiselect" id="dropdownZonaCuadrante">
                    <div class="selected-items" (click)="toggleDropdownZonaCuadrante()">
                        <span class="selected-text">{{ getZonaCuadranteLabel() }}</span>
                        <span class="custom-arrow">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <rect width="24" height="24" opacity="0"></rect>
                                <path d="M12 15.5a1 1 0 0 1-.71-.29l-4-4a1 1 0 1 1 1.42-1.42L12 13.1l3.3-3.18a1 1 0 1 1 1.38 1.44l-4 3.86a1 1 0 0 1-.68.28z"></path>
                            </svg>
                        </span>
                    </div>
                    <div class="dropdown" *ngIf="dropdownOpenZc">
                        <span class="search-icon">
                            <!-- ícono de búsqueda -->
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <!-- contenido del ícono -->
                            </svg>
                        </span>
                        <input
                            type="text"
                            placeholder="Buscar..."
                            [(ngModel)]="searchTermZc"
                            (ngModelChange)="filterZonaCuadranteOptions()"
                            class="search-input"
                        />
                        <div class="options-list">
                            <label class="option-label" *ngFor="let option of filteredZonaCuadrante">
                                <input
                                    type="checkbox"
                                    [checked]="zonaCuadranteProcesado.includes(option.value)"
                                    (change)="toggleZonaCuadranteOption(option.value)"
                                />
                                {{ option.label }}
                            </label>
                        </div>
                    </div>
                </div>


            </div>
            <div class="col-3 dropdownSelect">
                <!-- <p-multiSelect id="inputTipoAveria" defaultLabel="Tipo Avería"
                    [style]="{'width':'100%','height':'38px'}" name="ctrlMedioEgreso" [disabled]="" [options]="tipo"
                    [(ngModel)]="tipoProcesado" [showToggleAll]="false">
                </p-multiSelect> -->
                <!-- <nb-select
                    id="inputTipoAveria"
                    placeholder="Tipo Avería"
                    [multiple]="true"
                    name="ctrlMedioEgreso"
                    [(ngModel)]="tipoProcesado"
                    fullWidth
                >
                    <nb-option *ngFor="let option of tipo" [value]="option.value">
                    {{ option.label }}
                    </nb-option>
                </nb-select> -->


                <div class="custom-multiselect" id="dropdownTipoAveria">
                    <div class="selected-items" (click)="toggleDropdownTipoAveria()">
                        <span class="selected-text">{{ getTipoAveriaLabel() }}</span>
                        <span class="custom-arrow">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <rect width="24" height="24" opacity="0"></rect>
                            <path d="M12 15.5a1 1 0 0 1-.71-.29l-4-4a1 1 0 1 1 1.42-1.42L12 13.1l3.3-3.18a1 1 0 1 1 1.38 1.44l-4 3.86a1 1 0 0 1-.68.28z"></path>
                        </svg>
                        </span>
                    </div>
                    <div class="dropdown" *ngIf="dropdownOpenTipoAveria">
                        <span class="search-icon">
                        <!-- ícono de búsqueda -->
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <!-- contenido del ícono -->
                        </svg>
                        </span>
                        <input
                        type="text"
                        placeholder="Buscar..."
                        [(ngModel)]="searchTermTipoAveria"
                        (ngModelChange)="filterTipoAveriaOptions()"
                        class="search-input"
                        />
                        <div class="options-list">
                        <label class="option-label" *ngFor="let option of filteredTipoAveria">
                            <input
                            type="checkbox"
                            [checked]="tipoProcesado.includes(option.value)"
                            (change)="toggleTipoAveriaOption(option.value)"
                            />
                            {{ option.label }}
                        </label>
                        </div>
                    </div>
                </div>
    
            </div>
        </div>
        <div class="col-9  float-right grilla">
            <button nbButton shape="round" size="small" class="buttontz" style="margin-right: -15px !important; margin-bottom: 15px !important" (click)="traerDatos()">
                <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
            </button>             
            <app-spinner *ngIf="!showGrilla" ></app-spinner>
            <table [nbTreeGrid]="source" *ngIf="showGrilla">

                <tr nbTreeGridHeaderRow *nbTreeGridHeaderRowDef="allColumns"></tr>
                <tr nbTreeGridRow *nbTreeGridRowDef="let row; columns: allColumns"></tr>
            
                <ng-container [nbTreeGridColumnDef]="customColumn">
                    <th nbTreeGridHeaderCell *nbTreeGridHeaderCellDef>
                    {{customColumn}}
                    </th>
                    <td nbTreeGridCell *nbTreeGridCellDef="let row" (click)="stateTreeGrid()">
                    <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
                    {{row.data[customColumn]}}
                    </td>
                </ng-container>
            
                <ng-container *ngFor="let column of defaultColumns; let index = index"
                                [nbTreeGridColumnDef]="column">
                    <th nbTreeGridHeaderCell *nbTreeGridHeaderCellDef>
                    {{column}}
                    </th>
                    <td nbTreeGridCell *nbTreeGridCellDef="let row">{{row.data[column] || '-'}}</td>
                </ng-container>
            
            </table>
        </div>
    </nb-tab>
    <nb-tab *ngIf="usersRol.GESTIONAR_CRITERIOS_SIMILITUD" tabTitle="Modificación" tabIcon="edit-outline" responsive style="height: 75vh;">
        <div class="row">
            <div class="col-3 float-left">
                <p class="Titulo">Criterios de Similitud</p>
                <p-dropdown required class="limited-selector" id="inputSimilitud" placeholder="Seleccionar Similitud"
                    [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'4px'}" [options]="similitud"
                    [(ngModel)]="similitudSeleccionada" (onChange)="obtenerDescripcionDropdown(similitudSeleccionada)"
                    [virtualScroll]="true" [itemSize]="31" [filter]="true">
                </p-dropdown>
                <p>
                    <mat-form-field class="altaLabel">
                        <mat-label>Ingresar Descripción</mat-label>
                        <input matInput #message1 maxlength="80" [(ngModel)]="descripcionEditarSimilitud"
                            name="descripcionModificar">
                        <mat-hint align="end">{{message1.value.length}} / 80</mat-hint>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field class="altaLabel">
                        <mat-label>Ingresar Descripción Breve</mat-label>
                        <input matInput #message2 maxlength="40" [(ngModel)]="descripcionBreveEditarSimilitud"
                            name="descripcionBreveModificar">
                        <mat-hint align="end">{{message2.value.length}} / 40</mat-hint>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field class="altaLabel">
                        <mat-label>Ingresar Número de Orden</mat-label>
                        <input matInput #message3 maxlength="40" name="orden" type="number" min="0"
                            [(ngModel)]="numeroOrdenEditarSimilitud" name="OrdenModificar">
                        <mat-hint align="end">{{message3.value.length}} / 40</mat-hint>
                    </mat-form-field>
                </p>
                <p>
                    <app-spinner *ngIf="showSpinnerModificar"></app-spinner>
                    <button nbButton size="tiny" status="primary" class="buttontz" (click)="modificarCriterio()">Modificar</button>
                </p>
            </div>
            <div>
            </div>
            <div class="col-3 dropdownSelect">
                <!-- <p-multiSelect id="inputZonaCuadranteModificar" defaultLabel="Zona Cuadrante"
                    [style]="{'width':'100%','height':'38px'}" name="ctrlMedioEgreso" [disabled]=""
                    [options]="zonaCuadrante" [(ngModel)]="zonaCuadranteProcesadoModificar" [showToggleAll]="false">
                </p-multiSelect> -->
                  <nb-select
                    id="inputZonaCuadranteModificar"
                    placeholder="Zona Cuadrante"
                    [multiple]="true"
                    name="ctrlMedioEgreso"
                    
                    [(ngModel)]="zonaCuadranteProcesadoModificar"
                    fullWidth
                    >
                        <nb-option *ngFor="let option of zonaCuadrante" [value]="option.value">
                        {{ option.label }}
                        </nb-option>
                  </nb-select>
            </div>
            <div class="col-3 dropdownSelect">
                <!-- <p-multiSelect id="inputSeveridadModificar" defaultLabel="Severidad"
                    [style]="{'width':'100%','height':'38px'}" name="ctrlMedioEgreso" [disabled]=""
                    [options]="severidad" [(ngModel)]="severidadProcesadoModificar" [showToggleAll]="false">
                </p-multiSelect> -->
                 <nb-select
                    id="inputSeveridadModificar"
                    placeholder="Severidad"
                    [multiple]="true"
                    name="ctrlMedioEgreso"
                    [(ngModel)]="severidadProcesadoModificar"
                    fullWidth
                    >
                    <nb-option *ngFor="let option of severidad" [value]="option.value">
                    {{ option.label }}
                    </nb-option>
                </nb-select>
            </div>
            <div class="col-3 dropdownSelect">
                <!-- <p-multiSelect id="inputTipoAveriaModificar" defaultLabel="Tipo Avería"
                    [style]="{'width':'100%','height':'38px'}" name="ctrlMedioEgreso" [disabled]="" [options]="tipo"
                    [(ngModel)]="tipoProcesadoModificar" [showToggleAll]="false">
                </p-multiSelect> -->
                 <nb-select
                    id="inputTipoAveriaModificar"
                    placeholder="Tipo Avería"
                    [multiple]="true"
                    name="ctrlMedioEgreso"
                    [(ngModel)]="tipoProcesadoModificar"
                    fullWidth
                    >
                    <nb-option *ngFor="let option of tipo" [value]="option.value">
                    {{ option.label }}
                    </nb-option>
                </nb-select>
            </div>
        </div>
    </nb-tab>
</nb-tabset>